import { createAsyncThunk } from '@reduxjs/toolkit'
import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'

import { changeTranslation } from 'cng-common/features/translations'
import { IUser } from 'core-components/sitebuilder/models/IUser'

import { getLocales, getTranslations } from '../api'
import { defaultLocale, NAME } from '../configs'
import { prepareTranslations } from '../helpers/prepareTranslations'
import { ILocale, ITranslationState } from '../models'
import { setIsInitialized } from '../translationSlice'

export const initTranslationService = createAsyncThunk(
  `${NAME}/initialize`,
  async (_, thunkApi) => {
    const dispatch = thunkApi.dispatch
    const state = thunkApi.getState() as { app: { user: IUser }; translations: ITranslationState }
    const locales = await getLocales()

    // Set default locale
    const result = await getTranslations(defaultLocale)
    const translation = prepareTranslations(result)
    const configI18next: InitOptions = {
      resources: {
        0: {
          translation,
        },
      },
      fallbackLng: '0',
      debug: false,
      ns: ['translation'],
      defaultNS: 'translation',
      keySeparator: false,
      interpolation: {
        escapeValue: false,
        formatSeparator: ',',
      },
      react: {
        useSuspense: false,
      },
    }

    await i18n
      .use(initReactI18next)
      .init(configI18next)
      .then(() => {
        dispatch(setIsInitialized(true))
      })

    const userLang = state.app?.user.locale
    const userLocale = userLang && locales.find((el: ILocale) => el.value === userLang)

    await dispatch(changeTranslation(userLocale || defaultLocale))
  }
)
